import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, UntypedFormGroup, ValidationErrors } from '@angular/forms';

@Directive({
    selector: '[sampleCorrectionValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: SampleCorrectionValidatorDirective, multi: true }],
    standalone: false
})
export class SampleCorrectionValidatorDirective implements Validator {

  constructor() { }

  validate(formGroup: UntypedFormGroup): ValidationErrors | null {
    const lastNameControl = formGroup.controls['lastName'];
    const firstNameControl = formGroup.controls['firstName'];
    const middleInitialControl = formGroup.controls['middleInitial'];
    const suffixControl = formGroup.controls['suffix'];
    const aliasControl = formGroup.controls['alias'];
    const genderControl = formGroup.controls['gender'];
    const raceControl = formGroup.controls['race'];
    const dateOfBirthControl = formGroup.controls['dateOfBirth'];
    const ssnControl = formGroup.controls['ssn'];
    const sidControl = formGroup.controls['sid'];
    const docNumberControl = formGroup.controls['docNumber'];

    if (!lastNameControl
      || !firstNameControl
      || !middleInitialControl
      || !suffixControl
      || !aliasControl
      || !genderControl
      || !raceControl
      || !dateOfBirthControl
      || !ssnControl
      || !sidControl
      || !docNumberControl)
      return null;

    let validationErrors: ValidationErrors = {};

    // One of the fields must have a value
    if (!lastNameControl.value
      && !firstNameControl.value
      && !middleInitialControl.value
      && !suffixControl.value
      && !aliasControl.value
      && !genderControl.value
      && !raceControl.value
      && !dateOfBirthControl.value
      && !ssnControl.value
      && (!sidControl.value || sidControl.value === "VA")
      && !docNumberControl.value)
      validationErrors.noRequiredFields = true;

    return Object.keys(validationErrors).length > 0 ? validationErrors : null;
  }
}
